import React from 'react';
import PageLayout from '../components/common/PageLayout';
import { AiRetentionPanel } from '../components/customer/AiRetentionCampaign';

export default function CustomerRetentionPage() {
  return (
    <PageLayout
      title="AI Retention"
      showCustomerSectionTabs
      showBreadcrumbs={false}
      navLinks={[
        { url: '/finance/rates/', label: 'Manage Rate' },
      ]}
    >
      <AiRetentionPanel active variant="page" />
    </PageLayout>
  );
}
